import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Image as KonvaImage } from "react-konva";
import useImage from "use-image";

function LayerImage({ layer, width, height }) {
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    let url = "";

    if (typeof layer.image === "string") {
      url = layer.image;
    } else if (layer.image instanceof Blob) {
      url = URL.createObjectURL(layer.image);
    } else {
      url = layer.imageUrl || "";
    }

    setImageUrl(url);

    return () => {
      if (layer.image instanceof Blob) {
        URL.revokeObjectURL(url);
      }
    };
  }, [layer.image, layer.imageUrl]);

  const [image] = useImage(imageUrl);

  if (!image) return null;

  const imgWidth = image.width;
  const imgHeight = image.height;

  const scale = Math.min(width / imgWidth, height / imgHeight);
  const scaledWidth = imgWidth * scale;
  const scaledHeight = imgHeight * scale;

  const offsetX = (width - scaledWidth) / 2;
  const offsetY = (height - scaledHeight) / 2;

  return (
    <KonvaImage
      image={image}
      x={offsetX}
      y={offsetY}
      scale={{ x: scale, y: scale }}
      perfectDrawEnabled={false}
      opacity={layer.opacity ?? 1}
    />
  );
}

LayerImage.propTypes = {
  layer: PropTypes.shape({
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    imageUrl: PropTypes.string,
    x: PropTypes.number,
    y: PropTypes.number,
    opacity: PropTypes.number,
  }).isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default LayerImage;
